module.exports = __webpack_public_path__ + "img/ir.2613506b.jpg";